// apps/webapp/webapp/src/redesign/popover-two-column-table/popover-two-columns-styled-components.tsx

import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const iconHeight = 20;
const iconWidth = 20;

export const PaperContainer = styled(Box)(() => ({
  padding: 0,
  width: '100%',
}));

export const TitleContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  paddingInline: theme.spacing(4),
  paddingTop: theme.spacing(3),
}));

export const ContentWrapper = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingInline: theme.spacing(4),
  paddingBottom: theme.spacing(3),
}));

export const LabelContainer = styled(Box)(({ theme }) => ({
  minWidth: 140,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  color: theme.palette.text.secondary,
}));

export const IconWrapper = styled(Box)(() => ({
  width: iconWidth,
  height: iconHeight,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const ColoredIcon = styled(Box)(() => ({
  width: iconWidth,
  height: iconHeight,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& svg, & svg *': {
    stroke: '#646464',
  },
  '& svg': {
    width: iconWidth,
    height: iconHeight,
  },
}));

export const FallbackCircle = styled(Box)(({ theme }) => ({
  width: iconWidth,
  height: iconHeight,
  borderRadius: '50%',
  backgroundColor: theme.palette.action.hover,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 14,
  fontWeight: 600,
  color: theme.palette.text.secondary,
}));
